/** How long the user has to be exploring the map before the modal opens by itself. */
export const SAVE_RESEARCH_AUTO_OPEN_DELAY_MS = 15_000;
/** Once it has opened by itself, the modal does not open by itself again for this long. */
export const SAVE_RESEARCH_AUTO_OPEN_COOLDOWN_MS = 7 * 24 * 60 * 60 * 1000;

// Browser-wide on purpose (not per user): an anonymous visitor who logs in on the same browser
// has already been shown the modal, and the cooldown must not restart for them.
export const SAVE_RESEARCH_AUTO_OPENED_AT_KEY = 'rw:save-research-modal:auto-opened-at';
export const SAVE_RESEARCH_SAVED_KEY = 'rw:save-research-modal:saved';

const readStorage = (key: string): string | null => {
  try {
    return window.localStorage.getItem(key);
  } catch {
    return null;
  }
};

const writeStorage = (key: string, value: string) => {
  try {
    window.localStorage.setItem(key, value);
  } catch {
    // Private mode or blocked storage: the in-memory guard still limits it to one per page load.
  }
};

/** False when the user already saved a search here, or the modal opened by itself in the last 7 days. */
export const canAutoOpenSaveResearch = (now: number = Date.now()): boolean => {
  if (readStorage(SAVE_RESEARCH_SAVED_KEY)) return false;
  const lastAutoOpenedAt = Number(readStorage(SAVE_RESEARCH_AUTO_OPENED_AT_KEY));
  if (!lastAutoOpenedAt) return true;
  return now - lastAutoOpenedAt >= SAVE_RESEARCH_AUTO_OPEN_COOLDOWN_MS;
};

export const markSaveResearchAutoOpened = (now: number = Date.now()) =>
  writeStorage(SAVE_RESEARCH_AUTO_OPENED_AT_KEY, String(now));

/** A user who saved a search is never interrupted by the automatic opening again on this browser. */
export const markSaveResearchSaved = () => writeStorage(SAVE_RESEARCH_SAVED_KEY, String(Date.now()));
